module.exports = __webpack_public_path__ + "img/ALC200-1-EN.8e1549d9.jpg";